module.exports = __webpack_public_path__ + "static/img/image_transaction_background_bottom.8cbffcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_transaction_background_bottom.png
// module id = 385
// module chunks = 1